export default {
  signInWithGoogle: "Sign in with Google",
  signInWithTwitter: "Sign in with X (Twitter)",
  signInWithDiscord: "Sign in with Discord",
  closeError: "Close error",
  signingIn: "Signing you in...",
  // 与 store 中 loginError 持有的英文通用串保持一致：store 仅以该串作为 truthy 标志与埋点保留值，
  // 实际展示文案在此本地化，避免改动 store 契约与既有测试（AUTH-05）。
  authFailed: "Authentication failed. Please try again.",
};
